import React, { useEffect, useRef, useState } from "react";
import { SERVER_URL } from "../../config/config";
import Loader from "../Loader";

export default function CompanyGrid({ searchTerm }) {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [invoiceForm, setInvoiceForm] = useState({
    from_date: "",
    to_date: "",
  });

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const initFetch = async () => {
      setLoading(true);
      await fetchCompanies();
      setLoading(false);
    };

    initFetch();
  }, []);

  const fetchCompanies = async () => {
    try {
      const res = await fetch(SERVER_URL + "/tie_details/company_details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          paginate: {
            number_of_rows: 100,
            page_number: 1,
          },
          filter_fields: {},
        }),
      });

      const data = await res.json();

      if (data && data.company && Array.isArray(data.company[1])) {
        setCompanies(data.company[1]);
      }
    } catch (err) {
      console.error("Company fetch failed", err);
    }
  };

  const safeLower = (value) =>
    typeof value === "string" ? value.toLowerCase() : "";

  const display = (value) =>
    value !== null && value !== undefined && value !== "" ? value : "—";

  const startEdit = (company) => {
    setEditingId(company.id);
    setForm({
      allowed_ewb_count: company.allowed_ewb_count || "",
      active_upto: company.active_upto ? company.active_upto.split("T")[0] : "",
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setForm({});
  };

  const saveEdit = async (companyId) => {
    try {
      setSaving(true);

      const res = await fetch(
        `${SERVER_URL}/tie_details/company_eway/${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(form),
        },
      );

      const data = await res.json();

      if (!res.ok || !data || !data.company) {
        throw new Error("Update failed");
      }

      setEditingId(null);
      setForm({});

      setToast({
        type: "success",
        message: `EWB Limit updated to ${data.company.allowed_ewb_count}`,
      });

      setLoading(true);

      await fetchCompanies();
    } catch (err) {
      console.error(err);
      setToast({
        type: "error",
        message: "Failed to update EWB details",
      });
    } finally {
      setSaving(false);
      setLoading(false);
    }
  };

  const handleGenerateInvoice = async () => {
  /*
  try {
    const response = await fetch(
      `${SERVER_URL}/eway/cost_report_excel`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          from_date: invoiceForm.from_date,
          to_date: invoiceForm.to_date,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate invoice");
    }

    // If API returns an Excel file
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Cost_Report.xlsx";
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Generate Invoice Error:", err);
  }
  */

  console.log("clicked Generate!!!!");
  console.log(invoiceForm);

  setOpenInvoiceModal(false);
  setInvoiceForm({
    from_date: "",
    to_date: "",
  });
};

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), 3000);
    return () => clearTimeout(timer);
  }, [toast]);

  const ALERT_PRIORITY = {
    red: 1,
    orange: 2,
    green: 3,
  };

  const filteredCompanies = companies
    .filter((company) => {
      const search = safeLower(searchTerm);
      return (
        safeLower(company.company_name).includes(search) ||
        safeLower(company.gst_no).includes(search)
      );
    })
    .sort((a, b) => {
      const aStatus = a.alert_status || "green";
      const bStatus = b.alert_status || "green";
      return ALERT_PRIORITY[aStatus] - ALERT_PRIORITY[bStatus];
    });

  return (
    <>
      {toast && (
        <div className={`toast toast-${toast.type}`}>{toast.message}</div>
      )}

      {loading ? (
        <Loader text="Loading companies..." />
      ) : (
        <div className="company-grid">
          {filteredCompanies.map((company) => {
            const alertClass = company.alert_status
              ? "alert-" + company.alert_status.toLowerCase()
              : "alert-green";

            const isEditing = editingId === company.id;

            return (
              <div
                key={company.id}
                className={
                  "company-card " + alertClass + (isEditing ? " editing" : "")
                }
              >
                {/* HEADER */}
                <div className="card-header">
                  <h3>{company.company_name}</h3>

                  <div className="card-actions">
                    {isEditing ? (
                      <>
                        <button
                          className="btn-save"
                          onClick={() => saveEdit(company.id)}
                          disabled={saving}
                        >
                          {saving ? "Saving..." : "Save"}
                        </button>
                        <button
                          className="btn-cancel"
                          onClick={cancelEdit}
                          disabled={saving}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn-edit"
                        onClick={() => startEdit(company)}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>

                {/* BODY */}
                <div className="company-summary">
                  <div>
                    <span>GST</span>
                    {display(company.gst_no)}
                  </div>

                  <div>
                    <span>Contact</span>
                    {display(company.contact_no)}
                  </div>

                  <div>
                    <span>Email</span>
                    {display(company.mail_id)}
                  </div>

                  <div>
                    <span>Address</span>
                    {display(company.address)}
                  </div>

                  <div>
                    <span>Plan</span>
                    {display(company.plan)}
                  </div>

                  <div className="ewb-highlight">
                    <span>EWB Used</span>
                    {display(company.current_ewb_count)}
                  </div>

                  <div className="ewb-highlight">
                    <span>EWB Limit</span>
                    {isEditing ? (
                      <input
                        type="number"
                        className="inline-input"
                        value={form.allowed_ewb_count}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            allowed_ewb_count: e.target.value,
                          })
                        }
                      />
                    ) : (
                      display(company.allowed_ewb_count)
                    )}
                  </div>

                  <div className="ewb-highlight">
                    <span>Active Upto</span>
                    {isEditing ? (
                      <input
                        type="date"
                        className="inline-input"
                        value={form.active_upto}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            active_upto: e.target.value,
                          })
                        }
                      />
                    ) : company.active_upto ? (
                      new Date(company.active_upto).toLocaleDateString()
                    ) : (
                      "—"
                    )}
                  </div>

                  <div className="status">
                    <span>Status</span>
                    {company.is_active ? "Active" : "Inactive"}
                  </div>

                  {
                    company.id === 132 && (
                      <>
                        {isEditing && (
                          <div className="generate-invoice-container">
                            <button
                              className="generate-invoice-btn"
                              onClick={() => {
                                setInvoiceForm({
                                  from_date: "",
                                  to_date: "",
                                });
                                setOpenInvoiceModal(true);
                              }}
                            >
                              Generate Invoice
                            </button>
                          </div>
                        )}
                      </>
                    )
                  }
                </div>
              </div>
            );
          })}
        </div>
      )}
      {openInvoiceModal && 
        (
          <div className="invoice-modal-overlay">
            <div className="invoice-modal">

              <div className="invoice-modal-title">
                Generate Invoice
              </div>

              <div className="invoice-modal-subtitle">
                Select the date range.
              </div>

              <label className="invoice-field">
                <span>From Date</span>
                <input
                  type="date"
                  value={invoiceForm.from_date}
                  onChange={(e) =>
                    setInvoiceForm({
                      ...invoiceForm,
                      from_date: e.target.value,
                    })
                  }
                />
              </label>

              <label className="invoice-field">
                <span>To Date</span>
                <input
                  type="date"
                  value={invoiceForm.to_date}
                  onChange={(e) =>
                    setInvoiceForm({
                      ...invoiceForm,
                      to_date: e.target.value,
                    })
                  }
                />
              </label>

              <div className="invoice-modal-actions">
                <button
                  className="invoice-close-btn"
                  onClick={() => {
                    setOpenInvoiceModal(false);
                    setInvoiceForm({
                      from_date: "",
                      to_date: "",
                    });
                  }}
                >
                  Close
                </button>

                <button
                  className="invoice-generate-btn"
                  onClick={handleGenerateInvoice}
                >
                  Generate
                </button>
              </div>

            </div>
          </div>
        )
      }
    </>
  );
}
